import {rewriteData} from "./formatData"
import {VIEWTYPE} from "../../components/util/utilData"

const checkTdaData = (data, dispatch) => {
    if (data.tdaData.status === "running") {
        dispatch({
            type: "replaceDisplay",
            payload: {
                baseInfo: {
                    name: data.fileData.baseFile.fileName,
                    type: data.fileData.baseFile.fileName
                        .slice(data.fileData.baseFile.fileName.lastIndexOf(".") + 1)
                        .toLowerCase(),
                    url: data.fileData.baseFile.url,
                    hasData: true,
                    status: "success",
                },
                compareInfo: {
                    name: data.fileData.compareFile.fileName,
                    type: data.fileData.compareFile.fileName
                        .slice(data.fileData.compareFile.fileName.lastIndexOf(".") + 1)
                        .toLowerCase(),
                    url: data.fileData.compareFile.url,
                    hasData: true,
                    status: "success",
                },
            },
        })
        dispatch({type: "startComparison", payload: data.tdaData.taskId})
    } else if (data.tdaData.status === "error") {
        dispatch({
            type: "replaceDisplay",
            payload: {
                baseInfo: {
                    name: data.fileData.baseFile.fileName,
                    type: data.fileData.baseFile.fileName
                        .slice(data.fileData.baseFile.fileName.lastIndexOf(".") + 1)
                        .toLowerCase(),
                    url: data.fileData.baseFile.url,
                    hasData: true,
                    status: "success",
                },
                compareInfo: {
                    name: data.fileData.compareFile.fileName,
                    type: data.fileData.compareFile.fileName
                        .slice(data.fileData.compareFile.fileName.lastIndexOf(".") + 1)
                        .toLowerCase(),
                    url: data.fileData.compareFile.url,
                    hasData: true,
                    status: "success",
                },
            },
        })
        // let index = data.tdaData.progress.lastIndexOf(":")
        // const str = data.tdaData.progress.substring(index + 1, data.tdaData.progress.length)
        dispatch({
            type: "pollingError",
            payload: {
                progress: data.tdaData.progress,
                taskId: data.tdaData.taskId,
                traceId: data.tdaData.traceId,
            },
        })
    } else if (data.tdaData.status === "success") {
        dispatch({
            type: "pollingSuccess",
            payload: {
                taskId: data.tdaData.taskId,
            },
        })
        dispatch({
            type: "replaceDisplay",
            payload: {
                baseInfo: {
                    name: data.fileData.baseFile.fileName,
                    type: data.fileData.baseFile.fileName
                        .slice(data.fileData.baseFile.fileName.lastIndexOf(".") + 1)
                        .toLowerCase(),
                    url: data.fileData.baseFile.url,
                    hasData: true,
                    status: "success",
                },
                compareInfo: {
                    name: data.fileData.compareFile.fileName,
                    type: data.fileData.compareFile.fileName
                        .slice(data.fileData.compareFile.fileName.lastIndexOf(".") + 1)
                        .toLowerCase(),
                    url: data.fileData.compareFile.url,
                    hasData: true,
                    status: "success",
                },
            },
        })
        setTimeout(() => {
            dispatch({
                type: "queryStatus",
                payload: {
                    comparisonStatus: {
                        id: data.tdaData.taskId,
                        status: "success",
                        msg: "比对结束",
                    },
                    data: rewriteData(data.tdaData.compareData),
                },
            })
        }, 500)
    }
}

const checkData = (k, v, dispatch) => {
    switch (k) {
        case "init":
            if (v.viewType === VIEWTYPE.SHOW) {
                dispatch({type: "startLoading", payload: true})
                dispatch({type: k, payload: v})
                dispatch({type: "activeView", payload: "display"})
                checkTdaData(v.showData, dispatch)
            } else {
                dispatch({type: k, payload: v})
            }
            break
        case "startComparison":
            if (!(v === "validFileError") && !(v === "validLicenseError") && !(v === "systemError")) {
                dispatch({type: k, payload: v})
            } else {
                dispatch({type: "returnOperate", payload: ""})
                dispatch({type: "activeView", payload: "operate"})
            }
            break
        case "polling":
            if (v.status === "running") {
                dispatch({
                    type: "pollingLoading",
                    payload: {
                        taskId: v.taskId,
                    },
                })
            } else if (v.status === "error") {
                dispatch({
                    type: "pollingError",
                    payload: {
                        progress: v.progress,
                        taskId: v.taskId,
                        traceId: v.traceId,
                    },
                })
            } else if (v.status === "success") {
                dispatch({
                    type: "pollingSuccess",
                    payload: {
                        taskId: v.taskId,
                    },
                })
                setTimeout(() => {
                    dispatch({
                        type: "queryStatus",
                        payload: {
                            comparisonStatus: {
                                id: v.taskId,
                                status: "success",
                                msg: "比对结束",
                            },
                            data: rewriteData(v.compareData),
                        },
                    })
                }, 500)
            }
            break
        case "getAttachmentList":
            let allPageData = []
            v.forEach((item) => {
                item.data = item.data.map((oncePageData, index) => {
                    const timeStamp = new Date(oncePageData.uploadTime)
                    const Y = `${timeStamp.getFullYear()}-`
                    const M = `${
                        timeStamp.getMonth() + 1 < 10 ? `0${timeStamp.getMonth() + 1}` : timeStamp.getMonth() + 1
                    }-`
                    const D = `${timeStamp.getDate()} `
                    const uploadTime = Y + M + D
                    return {...oncePageData, uploadTime: uploadTime, index: index + 1}
                })
                allPageData.push(item)
            })
            dispatch({type: k, payload: allPageData})
            break
        case "getHistoricalDataList":
            v.sort((a, b) => {
                return a.creationDate < b.creationDate ? 1 : -1
            })
            const historicalList = v.map((item, index) => {
                return {...item, index: index + 1}
            })
            dispatch({type: k, payload: historicalList})
            break
        case "getHistoricalDetailById":
            checkTdaData(v, dispatch)
            break
        case "deleteHistoricalDetailById":
            if (v.status === true && v.code === 0) {
                dispatch({type: "doDeleteHistorical", payload: "doDeleteHistorical"})
            } else {
                // error报错
                dispatch({type: "outputMsg", payload: v.errorMsg})
            }
            break
        case "tdaBreakOff":
            dispatch({type: k, payload: v})
            break
        case "validBaseFile":
            v.validResult
                ? dispatch({
                      type: "replaceNewBaseAfterValid",
                      payload: {
                          status: "success",
                          tempFileId: v.tempFileId,
                      },
                  })
                : dispatch({
                      type: "replaceNewBaseAfterValid",
                      payload: {
                          status: "error",
                          tempFileId: "",
                      },
                  })
            break
        case "validCompareFile":
            v.validResult
                ? dispatch({
                      type: "replaceNewCompareAfterValid",
                      payload: {
                          status: "success",
                          tempFileId: v.tempFileId,
                      },
                  })
                : dispatch({
                      type: "replaceNewCompareAfterValid",
                      payload: {
                          status: "error",
                          tempFileId: "",
                      },
                  })
            break
        default:
            return
    }
}

export const processData = (data, dispatch) => {
    try {
        for (let key in data) {
            checkData(key, data[key], dispatch)
        }
    } catch (e) {
        dispatch({
            type: "outputMsg",
            payload: e.message,
        })
    }
}
